/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThinIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABT0lEQVR4nO2UvUpDQRCF10LRRsTS1ii2otZ2EjDzcwN7Z2KKdLcUH8HCOja+QkCCL6CW4lv402khiSkVBGWuiiK5m7hJmQNTLXxndubsOjfRl5j3NpC0DawtRF1y4xJRYwFIToD0DVnfrcxkHOwpTNI6kj5+g38ZnI5E3q3WVpD0/C84h9tNUNejwN77OSA5RNaXfvDPkuMoeCVJt4D1vhhs3ctDuVyfj+l8EUh7IXheSapR3WOi+4PgwHoZBTchyUV4NPpaqdbWXIy2G43Z8FJzgyMXK+/9DJDeBAzuLF1DAwF8CVnObKnA8gwsTWZZ7pcgO0fUzaHhzLIKpJ0+C2yZCZLc2rxtoUB6YOn61zis8+KUSDPLsmnbiYtVOOvSjQb/3KA4LUDaGQleYdkJPibSdjQcWK/DL1We7AeNNkCSq4Kx9PLIgi9FwydyA/QBOCE8Cx/RlRgAAAAASUVORK5CYII=)
 */
export const PaintbrushThinIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m9.17 12.67 2.16 2.16a1 1 0 0 0 .99.25l2.57-.75A3 3 0 0 0 16.6 13l4.91-8.05a1.8 1.8 0 0 0-2.47-2.47L11 7.39a3 3 0 0 0-1.32 1.72l-.75 2.57a1 1 0 0 0 .25.99ZM8.03 13.14c.27.07.51.23.7.43l1.7 1.7c.2.19.36.43.43.7A4 4 0 0 1 7 21H2a1 1 0 1 1 0-2c.68 0 1.13-.77 1.04-1.44a4 4 0 0 1 5-4.42Z"
        className={colorClass}
      />
    </svg>
  );
};
